import { DeliveryType, DiscountType, PaymentMethod } from '@models/ropolo';
import { OrderingInitialState } from './types';

export const orderingInitialState: OrderingInitialState = {
  customerState: {
    customer: undefined,
    selectedCustomerAddressId: '',
    displayAddCustomerModal: false,
    displayEditCustomerModal: false,
    errorOnAddingCustomer: undefined,
    phoneNumberForNewCustomer: undefined,
    defaultCustomerAddress: undefined,
    selectPhoneForSms: undefined,
  },
  orderState: {
    deliveryType: DeliveryType.SERVE,
    menus: [],
    selectedMenuItem: undefined,
    selectedTopping: [],
    paymentType: PaymentMethod.CARD,
    multiPayment: [],
    description: '',
    defaultDescriptions: [],
    tableNumber: undefined,
    preparationTime: 20,
    submittedOrder: undefined,
    submittedOrderLoading: false,
    submittedOrderError: undefined,
    order: undefined,
    canAdd: true,
    removedItems: [],
    isEdited: false,
    isMenuItemDetailsVisible: false,
    menuItemsCount: 0,
    note: '',
  },
  pricingState: {
    finalPrice: 0,
    sumOfPackagingCostItems: 0,
    tax: 0,
    sumOfItemsPrice: 0,
    totalPackagingCost: 0,
    sumOfItemToppingsPrice: 0,
    serviceChargeFinalPrice: 0,
    discountPackagingCost: 0,
    deliveryCost: 0,
    tip: 0,
    serviceChargeCostNumber: 0,
    discountType: undefined,
    discountAmount: 0,
    finalDiscountAmount: 0,
    serviceFeeValue: 0,
    serviceFeeType: DiscountType.PERCENTAGE,
    totalServiceFee: 0,
  },
  couponState: {
    coupon: undefined,
    couponCode: undefined,
    loading: false,
    isNew: false,
  },
  hasError: undefined,
};
